export const marketplaceContractAddress = "KT1Kbscd5zyESkp5xQitK7aYAXj8DEGiFzgh";
export const energizeContractAddress = "KT1RDB7Q8jKgQnarhDaHJx9xUyakemMnUk73";
export const marketplaceNftBigMap = "160618";